import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { modalMousedownTrackingFix } from 'site-modules/shared/utils/modal-tracking-fix';

export function FiltersModal({ isOpen, toggle, children, dataTrackingParent }) {
  const fireEvent = useCallback(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
      event_data: {
        action_name: TrackingConstant.ACTION_WIDGET_VIEW,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        creative_id: dataTrackingParent,
      },
    });
  }, [dataTrackingParent]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      contentClassName="rounded-5"
      onMouseDown={modalMousedownTrackingFix}
      scrollable
      onOpened={fireEvent}
    >
      {children}
    </Modal>
  );
}

FiltersModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  dataTrackingParent: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
